import { Injectable } from '@angular/core';
import { ServiceRepository } from '../service-repository';
import { Observable } from 'rxjs';
import { map, filter, catchError, mergeMap } from "rxjs/operators";
import { HttpParams } from "@angular/common/http";
import { ErrorServiceService } from '../Error/error-service.service'
import { HttpClient, HttpEvent, HttpErrorResponse, HttpEventType} from '@angular/common/http';
import {AppType,UserGroupList,NotificationModal} from '../../Model/notification/notificationModal'

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  constructor(
    private _repositoryService: ServiceRepository,
    private _errorService: ErrorServiceService
  ) { }

  getAppTypeList(username: string): Observable<AppType[]> {
    let params = new HttpParams();
    return this._repositoryService.getAll<AppType[]>(
      '/api/Admin/GetAppType/' + username, params)
      .pipe(
        map(data => data.map(data => new AppType().deserialize(data)))            
      )

  }
   getUserGroupList(username: string): Observable<UserGroupList[]> {
    let params = new HttpParams();
    return this._repositoryService.getAll<UserGroupList[]>(
      '/api/Admin/GetUserGroup/' + username, params)
      .pipe(
        map(data => data.map(data => new UserGroupList().deserialize(data)))            
      )

  }

  submitDetails(notification: NotificationModal) {    
    return this._repositoryService
      .createWithBody('/api/Admin/SubmitNotificationDetails', notification)
  }

  selectNotification(userId:string): Observable<NotificationModal>{
    // return this._repositoryService
    // .getDatawitHeaders('/api/Admin/GetNotificationMessage/'+ userId)
    let params = new HttpParams();
    return this._repositoryService.getAll<NotificationModal>(
      '/api/Admin/GetNotificationData/' + userId, params)
      .pipe(
        map(data => new NotificationModal().deserialize(data))            
      )

  }

  selectNotificationMessage(userId:string){
    return this._repositoryService.getDatawitHeaders('/api/Admin/GetNotificationMessage/'+userId)
  }
}
